import React, { forwardRef } from "react";
import { Checkbox as MaterialCheckbox, SvgIcon } from "@material-ui/core";
import { Done } from "@material-ui/icons";
import { Box } from "..";

const Checkbox = forwardRef(
  ({ Icon = SvgIcon, CheckedIcon = Done, ...props }, ref) => {
    return (
      <Box boxShadow={3} borderRadius={10} mr={1}>
        <MaterialCheckbox
          ref={ref}
          color="default"
          icon={Icon && <Icon />}
          checkedIcon={
            CheckedIcon && <Box component={CheckedIcon} color="blue.main" />
          }
          {...props}
        />
      </Box>
    );
  }
);

export default Checkbox;
